import React from 'react'
import {
    FacebookShareButton,
    PinterestShareButton,
    RedditShareButton,
    TwitterShareButton,
    FacebookIcon,
    PinterestIcon,
    RedditIcon,
    TwitterIcon,
  } from "react-share";
  import * as SocialShareFullStyles from './SocialShareFull.module.scss'
import { OutboundLink } from 'gatsby-plugin-google-gtag';
  import Yummly from '../images/yummly.svg'

  const SocialShareFull = ({shareURL, title, caption, pinterestImage, isRecipe, image}) => {
    
    return (
          
          <div className={SocialShareFullStyles.container}>
            
              <p className={SocialShareFullStyles.heading}>Share this: </p>
              <div className={SocialShareFullStyles.iconsContainer}>
                <div className={SocialShareFullStyles.networkContainer}>
                    <FacebookShareButton url={shareURL} quote={caption} >
                        <FacebookIcon size={48} round></FacebookIcon>
                    </FacebookShareButton>
                </div>
                <div className={SocialShareFullStyles.networkContainer}>
                    <TwitterShareButton url={shareURL} title={title} >
                        <TwitterIcon size={48} round></TwitterIcon>
                    </TwitterShareButton>
                </div>
                <div className={SocialShareFullStyles.networkContainer}>
                    <PinterestShareButton url={shareURL} media={pinterestImage} >
                        <PinterestIcon size={48} round></PinterestIcon>
                    </PinterestShareButton>
                </div>
                <div className={SocialShareFullStyles.networkContainer}>
                    <RedditShareButton url={shareURL} title={title} >
                        <RedditIcon size={48} round></RedditIcon>
                    </RedditShareButton>
                </div>
                {isRecipe ? <div className={SocialShareFullStyles.networkContainer}>
                    <OutboundLink target="_blank" rel="noreferrer" href={`https://www.yummly.com/urb/verify?url=${shareURL}&title=${title.split(' ').join('%20')}&image=https:${image}`}>
                        <Yummly className={SocialShareFullStyles.yumButton} />
                    </OutboundLink>
                </div> : <div></div>}
            
            </div>
          </div>
      )
  }

  export default SocialShareFull